<script>
import Swal from "sweetalert2";
import {ref} from "vue";
import {useRoute} from "vue-router";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {Share} from "@capacitor/share";
import {CallNumber} from "capacitor-call-number";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";

export default {
  name: "DetailsAdvertising",
  components: {NavbarPage, LoadingPage},

  setup() {

    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let user_id = ref(FreeWorld.PinkMan(localStorage.getItem('uid') , 'de'))

    let adver_id = useRoute().params.adver_id

    let loading = ref(false)

    let data_adver = ref(null)
    let mark = ref(false)


    function load_adver() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'adver', id: adver_id}, 'Element', true).then((result) => {

        loading.value = false
        let res = result.data

        if (res.status != 'error') {
          data_adver.value = res
          if (data_adver.value.marke == 1) mark.value = true
        } else {

          Swal.fire({
            text: "آگهی مورد نظر یافت نشد!",
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: "متوجه شدم",
            showClass: {
              popup: 'animate__animated animate__bounceInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__bounceOutUp'
            }
          }).then((result) => {
            if (result.isConfirmed) {
              history.back()
            }
          });

        }


      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, load_adver)
      })

    }
    load_adver()

    function share_list() {

      var navbar = document.getElementById('share_list')
      var img_navbar = document.getElementById('up_share_list_img')

      if (navbar.style.height !== '21rem') {
        navbar.style.height = '21rem'
        img_navbar.classList.toggle("clicked");
      } else {
        navbar.style.height = '0px'
        img_navbar.classList.toggle("clicked");
      }
    }
    function mark_prod(type) {

      let div_mark
      type === 'web' ? div_mark = document.getElementById('div_mark_web') : div_mark = document.getElementById('div_mark')

      div_mark.style.pointerEvents = 'none'
      mark.value = !mark.value
      let data = {
        action: 'add',
        item_id: adver_id,
        type: 'adver',
      }
      FreeWorld.Heisenberg(data, 'user_marke', true).then((result) => {
        let res = result.data

        setTimeout(() => {
          if (res.event == 'mark delete') {
            mark.value = false
          } else if (res.event == 'mark add') {
            mark.value = true
          }
          div_mark.style.pointerEvents = 'auto'
        }, 1000)

      }).catch(() => {

        setTimeout(() => {
          mark.value = !mark.value
          div_mark.style.pointerEvents = 'auto'
        }, 1000)

        console.log('don`t mark')
      })

    }

    function call_unit() {
      const userAgent = navigator.userAgent;
      if (userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/)) {
        CallNumber.call({number: data_adver.value.phone, bypassAppChooser: true});
      } else {
        Swal.fire({
          title: 'شماره آگهی دهنده',
          text: data_adver.value.phone,
          confirmButtonText: 'متوجه شدم',
        })
      }
    }

    function share_prod() {
      Share.share({
        title: data_adver.value.adver_name,
        text: 'اپلیکیشن دکوبان',
        url: 'https://decobanapp.ir',
        dialogTitle: 'اشتراک گذاری برای دیگران',
      });
    }


    return {

      share_list,
      loading,
      mark_prod,
      data_adver,
      mark,
      user_id,
      share_prod,
      call_unit,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div dir="ltr" :class="loading ? 'activeClass' : '' " id="main" class="bg-main">
    <div class="div-top-arrow bg-color d-flex align-items-center ">

      <p v-if="data_adver != null " class="m-0 d-flex">{{ data_adver.adver_name }}</p>

      <div onclick="history.back()">
        <img class="svg-arrow" src="../assets/img/back.svg" alt="">
      </div>

    </div>
    <br>
    <br>
    <br>

    <div v-if="data_adver != null" class="animate__animated animate__fadeIn">

      <div class="div_img_products p-body my-3">

        <div class="rounded-4">

          <img v-if="data_adver.pic.length == 0" class="w-100 h-100 rounded-4" src="../assets/img/img-notavalible.jpg"
               alt="">

          <v-carousel v-else
                      class="div_img_products rounded-4 "
                      :show-arrows="false"
                      hide-delimiter-background>
            <v-carousel-item
                v-for="(pic , i) in data_adver.pic"
                :key="i"
                class="img_products "
                :src="pic"
            ></v-carousel-item>
          </v-carousel>

        </div>

      </div>

      <div v-if="data_adver.type_partnership != null && data_adver.experience != null && data_adver.payment != null &&
     data_adver.military != null && data_adver.bime != null " class="p-body mb-2">
        <div class="p-3 bg-white rounded-4 border-costom ">

          <div v-if="data_adver.type_partnership != null ">
            <div class=" d-flex justify-content-between align-items-center py-2">
              <p class="m-0 font-5 mx-2">{{ data_adver.type_partnership }}</p>

              <p class="m-0 font-4">
                نوع همکاری
              </p>
            </div>
            <hr>
          </div>

          <div v-if="data_adver.experience != null ">
            <div class=" d-flex justify-content-between align-items-center py-2">
              <p class="m-0 font-5 mx-2">{{ data_adver.experience }}</p>
              <p class="m-0 font-4">
                نیاز به سابقه
              </p>
            </div>
            <hr>
          </div>

          <div v-if="data_adver.payment != null ">
            <div class=" d-flex justify-content-between align-items-center py-2">
              <p class="m-0 font-5 mx-2">{{ data_adver.payment }}</p>
              <p class="m-0 font-4">
                شیوه پرداخت
              </p>
            </div>
            <hr>
          </div>

          <div v-if="data_adver.bime != null ">
            <div class=" d-flex justify-content-between align-items-center py-2">
              <p class="m-0 mx-2 font-5">{{ data_adver.bime }}</p>
              <p class="m-0 font-4">
                بیمه
              </p>
            </div>
            <hr>
          </div>

          <div v-if="data_adver.military != null ">
            <div class=" d-flex justify-content-between align-items-center py-2">
              <p class="m-0 mx-2 font-5">{{ data_adver.military }}</p>
              <p class="m-0 font-4">
                وضعیت سربازی
              </p>
            </div>
          </div>

        </div>
      </div>

      <div class="p-body mb-2">
        <div class="d-flex flex-column p-3 bg-white rounded-4 border-costom align-items-center">
          <div class="w-100 d-flex align-items-center justify-content-end mb-3 align-items-center">
            <p class="font-4 m-0 mx-2 font-bold">
              :توضیحات و افتخارات
            </p>
            <img style="width: 20px" src="../assets/img/document.svg" alt="">
          </div>

          <div class="w-100">
            <p class="text-end m-0">{{ data_adver.description }}</p>
          </div>
        </div>
      </div>

    </div>


    <div v-if="data_adver != null" class="div_share z-3">
      <div @click="share_list" class="holder_navbar_share z-5">
        <img id="up_share_list_img" style="width: 4rem" src="../assets/img/up_down.svg" alt="">
      </div>

      <div id="share_list" class="share_list d-flex flex-column bg-color px-1 align-items-center">
        <br>
        <div @click="share_prod" class="d-flex flex-column align-items-center mb-2">
          <img style="width: 25px" src="../assets/img/share.svg" alt="">
          <p class="m-0 font-7 text-white text-center my-2">
            اشتراک گذاری
          </p>
        </div>

        <div id="div_mark" @click="mark_prod" class="d-flex flex-column align-items-center mb-2">
          <img v-if="mark" style="width: 25px" src="../assets/img/save_mark.svg" alt="">
          <img v-else style="width: 25px" src="../assets/img/bookmark-white.svg" alt="">
          <p class="m-0 font-7 text-white text-center my-2">
            نشان کردن
          </p>
        </div>

        <div v-if="data_adver.user_id == user_id || data_adver.chat_active == 0 "
             class="d-flex flex-column align-items-center mb-2">
          <img style="width: 25px" src="../assets/img/disable_chats.svg" alt="">
          <p style="color:#717171FF" class="m-0 font-5 text-center my-2">
            چت
          </p>
        </div>

        <router-link v-else
             :to="{name:'UserChat', params:{user_id:user_id , type:'adver' , send:'user' , prof_id:data_adver.id , name:data_adver.adver_name}}"
             class="text-decoration-none">
          <div class="d-flex flex-column align-items-center mb-2">
            <img style="width: 25px" src="../assets/img/chat.svg" alt="">
            <p class="m-0 font-6 text-white text-center my-2">
              چت
            </p>
          </div>
        </router-link>


        <div @click="call_unit" class="d-flex flex-column align-items-center mb-2">
          <img style="width: 25px" src="../assets/img/telephone.svg" alt="">
          <p class="m-0 font-5 text-white text-center my-2 text-nowrap">
            تماس
          </p>
        </div>

      </div>
    </div>

  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">
    <NavbarPage></NavbarPage>

    <div v-if="data_adver != null" class="position-relative d-flex">

      <div style="left:0;width: calc(100% - 11.5rem)" class="position-absolute">
        <div class="w-90 p-body">
          <div class="animate__animated animate__fadeIn">
            <div class="d-flex justify-space-between mb-7">
              <div style="width: 30%;height: 300px" class="rounded-4 my-3">

                <img v-if="data_adver.pic.length == 0" class="div_img_products rounded-4"
                     src="../assets/img/img-notavalible.jpg"
                     alt="">

                <v-carousel v-else
                            class="div_img_products rounded-4 "
                            :show-arrows="false"
                            hide-delimiter-background>
                  <v-carousel-item
                      v-for="(pic , i) in data_adver.pic"
                      :key="i"
                      class="img_products"
                      :src="pic"
                  ></v-carousel-item>
                </v-carousel>
              </div>

              <div class="d-flex flex-column w-66 justify-content-center">
                <div class="">
                  <div class="d-flex p-3 bg-white rounded-4 border-costom justify-content-between align-items-center">
                      <p class="m-0 d-flex font-bold font-5">{{ data_adver.adver_name }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-2">
              <div class="d-flex flex-column p-3 bg-white rounded-4 border-costom align-items-center">
                <p class="font-5 font-bold w-100">
                  توضیحات محصول :
                </p>
                <div class="w-100">
                  <p class="font-5 w-100 m-0">{{ data_adver.description }}</p>
                </div>

              </div>
            </div>

            <div v-if="data_adver.type_partnership != null && data_adver.experience != null && data_adver.payment != null && data_adver.military != null && data_adver.bime != null " class="mb-5">
              <div class="p-3 bg-white rounded-4 border-costom ">

                <div v-if="data_adver.type_partnership != null ">
                  <div class=" d-flex justify-content-between align-items-center py-2">
                    <p class="m-0 font-5 font-bold">
                      نوع همکاری
                    </p>

                    <p class="m-0 mx-2">{{ data_adver.type_partnership }}</p>
                  </div>
                  <hr>
                </div>

                <div v-if="data_adver.experience != null ">
                  <div class=" d-flex justify-content-between align-items-center py-2">
                    <p class="m-0 font-5 font-bold">
                      نیاز به سابقه
                    </p>

                    <p class="m-0 mx-2">{{ data_adver.experience }}</p>
                  </div>
                  <hr>
                </div>

                <div v-if="data_adver.payment != null ">
                  <div class=" d-flex justify-content-between align-items-center py-2">
                    <p class="m-0 font-5 font-bold">
                      شیوه پرداخت
                    </p>

                    <p class="m-0 mx-2">{{ data_adver.payment }}</p>
                  </div>
                  <hr>
                </div>

                <div v-if="data_adver.bime != null ">
                  <div class=" d-flex justify-content-between align-items-center py-2">
                    <p class="m-0 font-5 font-bold">
                      بیمه
                    </p>

                    <p class="m-0 mx-2">{{ data_adver.bime }}</p>
                  </div>
                  <hr>
                </div>

                <div v-if="data_adver.military != null ">
                  <div class=" d-flex justify-content-between align-items-center py-2">
                    <p class="m-0 font-5 font-bold">
                      وضعیت سربازی
                    </p>

                    <p class="m-0 mx-2">{{ data_adver.military }}</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="right: 0;width: 10rem;height: calc(100vh - 10rem)"
           class="animate__animated animate__fadeIn gap-4 position-fixed mr-5 d-flex flex-column justify-content-evenly align-items-center">

        <div @click="share_prod" class="item_share d-flex flex-column align-items-center ">
          <img style="width: 1.3rem;height: 1.3rem" src="../assets/img/share_web.svg" alt="">
          <p class="m-0 font-5 text-center my-2">
            اشتراک گذاری
          </p>
        </div>

        <div id="div_mark_web" @click="mark_prod('web')" class="item_share d-flex flex-column align-items-center">
          <img v-if="mark" style="width: 1.3rem;height: 1.3rem" src="../assets/img/save_mark_web.svg" alt="">
          <img v-else style="width: 1.3rem;height: 1.3rem" src="../assets/img/bookmark-white-web.svg" alt="">
          <p class="m-0 font-5 text-center my-2">
            نشان کردن
          </p>
        </div>

        <div @click="call_unit()" class="item_share d-flex flex-column align-items-center ">
          <img style="width: 1.3rem;height: 1.3rem" src="../assets/img/telephone-web.svg" alt="">
          <p class="m-0 font-5 text-center my-2 text-nowrap">
            تماس
          </p>
        </div>

        <div v-if="data_adver.user_id == user_id || data_adver.chat_active == 0 "
             class="d-flex flex-column align-items-center">
          <img style="width: 1.3rem;height: 1.3rem" src="../assets/img/disable_chats.svg" alt="">
          <p style="color:#717171FF" class="m-0 font-5 text-center my-2">
            چت
          </p>
        </div>

        <router-link v-else :to="{name:'UserChat', params:{user_id:user_id , type:'adver' , send:'user' , prof_id:data_adver.id , name:data_adver.adver_name}}"
             class="item_share text-decoration-none">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 1.3rem;height: 1.3rem" src="../assets/img/chat-web.svg" alt="">
            <p class="m-0 font-5 text-center my-2">
              چت
            </p>
          </div>
        </router-link>

      </div>
    </div>
  </div>
</template>

<style scoped>

.div_img_products {
  width: 100% !important;
  height: 300px !important;
}

.img_products {
  width: 100% !important;
  height: 100% !important;
}

.share_list {
  width: 4rem;
  height: 0px;
  overflow: hidden;
  transition: 0.5s;
}

.div_share {
  position: fixed;
  padding-left: 15px;
  bottom: 40px;
  width: 100%;
  max-width: 500px;
}

.holder_navbar_share {
  position: fixed;
  bottom: 15px;
  transition: transform 0.5s ease-in-out;
  transform-origin: center center;
}

.clicked {
  transform: rotate(180deg);
}

#share_list {
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}



#share_list {
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
.item_share{
  width: 90%;
  transition: .5s;
  border-radius: 30px;
  padding: 2% 0;
  white-space: nowrap;
  overflow: visible;
  text-decoration: none;
  color: #e15900
}
.item_share:hover{
  background-color: #818285;
  color: white !important;
  outline: 1px solid #e15900;
}
</style>